import { BaseCell } from 'src/components/TableV2/cells/BaseCell';
import { useRowRenderOptimization } from 'src/contexts/RowRenderOptimizationContext/RowRenderOptimizationContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { Stack } from 'src/core/ui';
import { FormatOption } from 'src/modals/EditTableColumns';
import { ListingWithEvent } from 'src/tables/ListingTable/ListingTable.types';

import { GroupAnchor } from './GroupAnchor';
import * as styles from './SeatingColumnCell.css';
import { SeatingDisplay } from './SeatingDisplay';

export const SeatingColumnCell = ({
  original,
  userDefinedPrecision,
}: {
  original: ListingWithEvent;
  userDefinedPrecision: FormatOption;
}) => {
  const { isDarkMode } = useSiteTheme();
  const rowRenderOptimization = useRowRenderOptimization();

  const listing = original.listing;

  if (!listing) {
    return null;
  }

  const adjustedListing =
    userDefinedPrecision === FormatOption.Seating_SectionOnly
      ? {
          ...listing,
          seating: {
            ...listing.seating,
            row: null,
            seatFr: null,
            seatTo: null,
          },
        }
      : listing;

  const seatingDisplay = (
    <SeatingDisplay
      listing={adjustedListing}
      title={original.selectionDisabledReason}
      showOrgSeat={
        userDefinedPrecision === FormatOption.Seating_OriginalSeating
      }
    />
  );

  const groupAnchor = original.ltGroupName ? (
    <GroupAnchor ltGroupName={original.ltGroupName} isDarkMode={isDarkMode} />
  ) : null;

  // Optimized: two redundant single-child Stack wrappers and the flex wrapper
  // around the group anchor are removed.
  if (rowRenderOptimization) {
    return (
      <BaseCell>
        <Stack
          direction="row"
          justifyContent="spaceBetween"
          width="full"
          alignItems="center"
        >
          {seatingDisplay}
          {groupAnchor}
        </Stack>
      </BaseCell>
    );
  }

  return (
    <BaseCell>
      <Stack direction="row" gap="m" alignItems="center" width="full">
        <Stack
          direction="row"
          justifyContent="spaceBetween"
          width="full"
          alignItems="center"
        >
          {seatingDisplay}
          <div className={styles.anchorWrapper}>{groupAnchor}</div>
        </Stack>
      </Stack>
    </BaseCell>
  );
};
